import {
  IQuickVideoPartTestSendForm,
  QuickVideoPartType,
} from 'lib/api/quickVideo/types';
import * as Yup from 'yup';

export const testSendValidation = () => {
  return Yup.object({
    recipientName: Yup.string()
      .max(60, 'Recipient name can have at most 60 characters')
      .required('Recipient name is required'),
    inventoryItemId: Yup.number().moreThan(0).required('Vehicle is required'),
    quickVideoParts: Yup.array().test(
      'user-video-selected',
      'Please select a user video.',
      (quickVideoParts: IQuickVideoPartTestSendForm[]) => {
        const userVideo = (quickVideoParts || []).filter(
          part => part.partType === QuickVideoPartType.USER_VIDEO
        );

        if (!userVideo.length) {
          return true;
        }

        if (userVideo.some(part => !part.video || !part.video.id)) {
          return false;
        }

        return true;
      }
    ),
  });
};
